export default __webpack_public_path__ + "static/media/banner.ef73d26d.jpg";